import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FADE_ANIMATION_IN } from 'src/components/common/styles';

const Container = styled.main`
  grid-area: main;
  min-height: calc(100vh - 70px);
  background-color: white;
  overflow-y: auto;
  will-change: opacity;
  ${FADE_ANIMATION_IN('MEDIUM_TRANSIT')};
  z-index: 1;

  //Custom Code
  background-color: #f5f5f5;
  padding-left: 24px;
  padding-right: 24px;
  
`;

// Changed bg color for Main

const SubContainer = styled.div`
  max-width: var(--main-max-width);
  height: calc(100vh - 70px);
  padding-top: 50px;
  margin: auto;
  //Custom Styling
  max-width: 1400px;
  margin: 0 auto;
`;

function Main({ children }) {
  return (
    <Container>
      <SubContainer>
        {children}
      </SubContainer>
    </Container>
  );
}

Main.propTypes = {
  children: PropTypes.node,
};

export default Main;
